import type { FC } from 'react';
import { SportCompetitorLeadSideIcon } from '@/components/SportCompetitorLeadSideIcon/SportCompetitorLeadSideIcon';
import type { MatchLiveProps } from './MatchLive.types';
import styles from './MatchLive.module.scss';
export const MatchLive: FC<MatchLiveProps> = ({
  className,
  status,
  time,
  score,
  line,
  singleCompetitor
}) => {
  return <div className={cn(styles.root, className)} data-sentry-component="MatchLive" data-sentry-source-file="MatchLive.tsx">
      <div className={cn(styles.statRow, {
      [styles.withoutTime]: !time
    })}>
        {status && <div className={styles.status}>{status}</div>}
        {time && <div className={styles.time}>{time}</div>}
      </div>

      {score && !singleCompetitor && <div className={styles.scoreRow}>
          <div className={styles.score}>
            <SportCompetitorLeadSideIcon side="HOME" line={line} />
            <span className={styles.scoreValue}>{score.HOME}</span>
            <span className={styles.scoreColon}>:</span>
            <span className={styles.scoreValue}>{score.AWAY}</span>
            <SportCompetitorLeadSideIcon side="AWAY" line={line} />
          </div>
        </div>}
    </div>;
};